import { useCallback } from "react";

import type { HotelTemplateSettingsUpdateInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { HotelTemplateSettingsUpdateMutation } from "./mutation";

export const useUpdateHotelTemplateSettings = () => {
	const { mutationFunc } = useCustomMutation(HotelTemplateSettingsUpdateMutation);

	const updateHotelTemplateSettings = useCallback(
		async (hotelTemplateSettings: HotelTemplateSettingsUpdateInput) => {
			return await mutationFunc({
				variables: {
					input: hotelTemplateSettings,
				},
			});
		},
		[mutationFunc],
	);

	return {
		updateHotelTemplateSettings,
	};
};
